import React, { useEffect, useState, useRef, useReducer } from 'react';
import ReactGA from 'react-ga';
import { createBrowserHistory } from "history";
import AppDataProvider from "./components/../__providers/AppProvider";

import './assets/css/core.css';
import { Switch, Route, useLocation } from "react-router-dom";
import { useAuthDataContext } from './components/../__providers/AuthProvider';
import Home from './components/Home';
import Contacts from './components/Contacts';
import Header from './components/Header';
import Footer from './components/Footer';
import AboutSchools from './components/about/Schools';
import AboutStudents from './components/about/Students';
import AboutStudentsNew from './components/about/StudentsNew';
import DrivingSchools from './components/schools/DrivingSchools';
import Settings from './components/settings/Index';
import InstructorProfileEdit from './components/profile/instructor/InstructorProfileEdit';
import License from './components/license/License';
import Register from './components/register/Register';
import RegisterSchool from './components/register/School';
import Practice from './components/Practice';
import Profile from './components/profile/student/Profile';
import ProfileEdit from './components/profile/student/ProfileEdit';
import Topic from './components/topic/Topic';
import SchoolProfileEdit from './components/profile/school/SchoolProfileEdit';
import Tests from './components/tests/Tests';
import Cookies from './components/policies/Cookies';
import Privacy from './components/policies/Privacy';
import Terms from './components/policies/Terms';
import ProtectedRoute from './components/routes/ProtectedRoute';
import NotFound from './components/error/404';
import ServerError from './components/error/500';
import Unauthorised from './components/error/403';
import Store from './components/store/Index';
import BankInfo from './components/store/BankInfo';
import LiveNotifications from './components/../__providers/NotificationsListener';
import Demo from './components/demo/Index'
import DemoTest from './components/demo/test/Test'
import InteractiveRoadSignals from './components/interactive_road_signals/Index';

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

//actions
import { handleModal } from './__actions/globalModals'
import { refreshNotification } from './__actions/notifications'

//modals
import MajorGuide from './components/modals/profile/guides/Major'
import TestsGuide from './components/modals/profile/guides/Tests'
import WatchedFirstVideoOfFirstTopicActivated from './components/STRUCTURE_MIGRATION/modals/messages/WatchedFirstVideoOfFirstTopicActivated'
import WatchedFirstVideoOfFirstTopic from './components/STRUCTURE_MIGRATION/modals/messages/WatchedFirstVideoOfFirstTopic'
import JustRegistered from './components/STRUCTURE_MIGRATION/modals/messages/JustRegistered'
import Feedback from './components/STRUCTURE_MIGRATION/modals/messages/Feedback'
import JustActivated from './components/STRUCTURE_MIGRATION/modals/messages/JustActivated'
import JustConfirmed from './components/STRUCTURE_MIGRATION/modals/messages/JustConfirmed'
import ActivationExpires from './components/STRUCTURE_MIGRATION/modals/messages/ActivationExpires'

//views
import TradeObjects from './views/trade_objects/Index'
import Search from './views/search/Index'
import InstructorTopics from './views/theory/instructor/Topics'
import Dashboard from './views/dashboard/Index'

//
import './assets/css/app.css'


function App() {
  const auth = useAuthDataContext();

  const [app, setApp] = useState({
    blackFonts: false,
    basicHeader: false,
    loginModal: false,
    activateModal: false,
  });


  let location = useLocation();

  useEffect(() => {

    //GA new-code G-T40C24JWPM 
    ReactGA.initialize('UA-49629535-2', {
      debug: false,
      titleCase: false,
      gaOptions: {
        userId: auth.user.id
      }
    });
    const history = createBrowserHistory();
    ReactGA.set({ page: history.location.pathname });
    ReactGA.pageview(history.location.pathname);

    if (document.URL.indexOf("/r/") > -1) {
      let key = document.location.href.split('/')[4];

      window.localStorage.setItem('r', key);
      window.location.href = `/`;
    } else if (document.URL.indexOf("/s/") > -1) {
      let key = document.location.href.split('/')[4];

      window.localStorage.setItem('s', key);
      window.location.href = `/`;
    }


    // if (location.pathname === '/' && !auth.isLogged) {
    //   setApp(app => {
    //     return { ...app, blackFonts: true, basicHeader: false };
    //   })
    // } else {
    //   setApp(app => {
    //     return { ...app, blackFonts: false, basicHeader: false };
    //   })
    // }

    if (location.pathname === '/cookies' || location.pathname === '/privacy' || location.pathname === '/terms') {
      setApp(app => {
        return { ...app, basicHeader: true };
      })
    } else {
      setApp(app => {
        return { ...app, basicHeader: false };
      })
    }

    const titles = {
      '/': 'Авто Обучение за кандидат-шофьори',
      '/about-students': 'Авто Обучение за курсисти',
      '/about-schools': 'Авто Обучение за инструктори',
      '/driving-schools': 'Шофьорски курсове',
      '/contacts': 'Контакти',
      '/register': 'Регистрация'
    };

    const path = location.pathname;

    let title;

    if (titles[path]) {
      title = titles[path];
    }

    if (title) {
      document.title = title;
    } else {
      document.title = titles['/'];
    }

  }, [location, auth]);

  const type = auth.user ? auth.user.user_type_id : 0;

  const handleLoginModal = e => {
    setApp(app => {
      return { ...app, loginModal: e };
    })
  }

  // if(location.pathname === '/try'){
  //   window.location.href = `/`;
  //   return
  // }



  //new code
  const dispatch = useDispatch()
  //
  const __globalModals = useSelector(state => state)
  //
  const globalModals = __globalModals.globalModalsReducer
  //

  //refs
  const majorGuideRef = useRef(null)
  const testsGuideRef = useRef(null)
  const watchedFirstVideoOfFirstTopicRef = useRef(null)
  const justRegisteredRef = useRef(null)
  const feedbackModalRef = useRef(null)
  const justActivatedModalRef = useRef(null)
  const justConfirmedModalRef = useRef(null)
  const activationExpiresModalRef = useRef(null)

  const topics = document.querySelector('#profileThemes .bottom li')

  useEffect(() => {
    if (auth?.isLogged && auth?.user?.is_student) {
      //Видетото на бутона Започни
      if (globalModals?.MAJOR_GUIDE?.show) majorGuideRef.current.open()
      //Видеото на бутона Листовки
      else if (globalModals?.TESTS_GUIDE?.show) testsGuideRef.current.open()
      //Прозорец, след като изгледа първото видео
      else if (globalModals?.WATCHED_FIRST_VIDEO?.show) watchedFirstVideoOfFirstTopicRef.current.open()
      //Прозорец, след като се регистрира
      else if (globalModals?.JUST_REGISTERED?.show) justRegisteredRef.current.open()
      //Прозорец, след тема 3 и/или тема 5
      else if (globalModals?.FEEDBACK?.show) feedbackModalRef.current.open()
      //Прозорец активация
      else if (globalModals?.JUST_ACTIVATED?.show) justActivatedModalRef.current.open()
      //Прозорец след потвърждение от автошкола
      else if (globalModals?.JUST_CONFIRMED?.show) justConfirmedModalRef.current.open()
      //Прозорец, когато срока на активция изтича
      else if (globalModals?.ACTIVATION_EXPIRES?.show) activationExpiresModalRef.current.open()
    }

  }, [topics, globalModals])

  useEffect(() => {
    if (auth?.isLogged && auth?.user?.is_student) {
      dispatch(handleModal(undefined, ''))
      dispatch(refreshNotification())
    }

    document.documentElement.scrollTop = 0

  }, [location.pathname])

  return (
    <div className="App">
      {auth.isLogged ?
        <>
          <ActivationExpires ref={activationExpiresModalRef} />
          <JustConfirmed ref={justConfirmedModalRef} />
          <JustActivated ref={justActivatedModalRef} />
          <Feedback ref={feedbackModalRef} />
          {globalModals?.MAJOR_GUIDE?.show ? <MajorGuide ref={majorGuideRef} /> : ''}
          {globalModals?.TESTS_GUIDE?.show ? <TestsGuide ref={testsGuideRef} /> : ''}
          {auth.user.activated ?
            <WatchedFirstVideoOfFirstTopicActivated ref={watchedFirstVideoOfFirstTopicRef} />
            :
            <WatchedFirstVideoOfFirstTopic ref={watchedFirstVideoOfFirstTopicRef} />
          }
          <JustRegistered ref={justRegisteredRef} />
        </>
        :
        ''
      }
      <AppDataProvider>
        <LiveNotifications>
          <Header
            openLogin={app.loginModal}
            closeLogin={handleLoginModal}
            headerBlackFonts={app.blackFonts}
            basicHeader={app.basicHeader}
          />

          <Route render={({ location }) => (
            <Switch onUpdate={location.pathname == '/store' ? '' : ''} location={location}>

              {auth.isLogged ?
                <ProtectedRoute userType={type} path="/" exact component={InteractiveRoadSignals} />
                :
                <Route path="/" exact component={Home} />
              }
              <Route path="/contacts" exact component={Contacts} />
              <Route path="/cookies" exact component={Cookies} />
              <Route path="/privacy" exact component={Privacy} />
              <Route path="/terms" exact component={Terms} />



              <Route path="*" render={(props) => <NotFound {...props} />} />
              <Route path="/500" render={(props) => <ServerError {...props} />} />
            </Switch>
          )} />
          <Footer />
        </LiveNotifications>
      </AppDataProvider>
    </div>
  );
}

export default App;
